export default "__VITE_ASSET__HcEtmabb__"